import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { FormControl } from '@angular/forms';
/**
 * 検索入力フィールド
 *【ラベル内容:labelContent:string】
 *【表示文言:label:string】
 *【内容:content:string】
 *【プレースホルダ:placeholder:string】
 *【表示条件:visible:boolean】
 *【非活性:disabled:boolean】
 *【クリアボタン:shouldShowClearButton:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-search-input-field',
  templateUrl: './search-input-field.html',
  styles: [`
    
  `]
})
export class SearchInputField extends BaseWidget {
  /**
   * 内容の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 内容に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * 表示文言
   */
  @Input() label:string

  /**
   * 内容
   */
  @Input() content:string

  /**
   * プレースホルダ
   */
  @Input() placeholder:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * クリアボタン
   */
  @Input() shouldShowClearButton:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get isInputData() {
    const inputData = {
      label: (this.shouldShowClearButton && (!this.content || this.content.length === 0)) ? '' : this.label,
      value: this.content
    }
    return inputData;
  }
  
  clear(event) {
    this.store.dispatch(this.actionCreator.resetViewModel(
      this.viewModelPath,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ));
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/search-input-field/search-input-field.component.ts